import React, { useState } from 'react';
import { XIcon, TrashIcon, ArrowRightIcon, CheckCircleIcon, CreditCardIcon, ShoppingBagIcon, DownloadIcon } from 'lucide-react';
import { CartItem } from './CartItem';
interface CartDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  items: any[];
  onRemove: (id: string) => void;
  onClear: () => void;
}
export const CartDrawer = ({
  isOpen,
  onClose,
  items,
  onRemove,
  onClear
}: CartDrawerProps) => {
  const [checkoutStep, setCheckoutStep] = useState('cart'); // 'cart', 'payment', 'confirmation'
  const [paymentMethod, setPaymentMethod] = useState('');
  const handleProceed = () => {
    if (checkoutStep === 'cart') {
      setCheckoutStep('payment');
    } else if (checkoutStep === 'payment') {
      // Process payment logic would go here
      setCheckoutStep('confirmation');
    } else {
      // Reset and close
      setCheckoutStep('cart');
      onClose();
    }
  };
  const handleBack = () => {
    if (checkoutStep === 'payment') {
      setCheckoutStep('cart');
    } else if (checkoutStep === 'confirmation') {
      setCheckoutStep('payment');
    }
  };
  const renderCartStep = () => <>
      <div className="flex-1 overflow-y-auto p-4" data-id="element-19">
        {items.length === 0 ? <div className="flex flex-col items-center justify-center h-full text-center text-gray-500" data-id="element-20">
            <ShoppingCartIcon className="h-16 w-16 mb-4 text-gray-300" data-id="element-21" />
            <p className="text-lg font-medium" data-id="element-22">আপনার কার্ট খালি</p>
            <p className="text-sm mt-1" data-id="element-23">(Your cart is empty)</p>
            <button className="mt-4 px-4 py-2 bg-blue-100 text-blue-800 rounded-md hover:bg-blue-200" onClick={onClose} data-id="element-24">
              খতিয়ান খুঁজুন
              <span className="text-xs block" data-id="element-25">(Search for Khatians)</span>
            </button>
          </div> : <div className="space-y-3" data-id="element-26">
            {items.map(item => <CartItem key={item.id} item={item} onRemove={() => onRemove(item.id)} data-id="element-27" />)}
          </div>}
      </div>
      {items.length > 0 && <div className="p-4 border-t" data-id="element-28">
          <div className="flex justify-between mb-4" data-id="element-29">
            <button className="flex items-center text-red-600 hover:text-red-800" onClick={onClear} data-id="element-30">
              <TrashIcon className="h-4 w-4 mr-1" data-id="element-31" />
              <span data-id="element-32">সব মুছুন</span>
              <span className="text-xs ml-1" data-id="element-33">(Clear All)</span>
            </button>
            <div className="text-right" data-id="element-34">
              <div className="text-sm text-gray-500" data-id="element-35">মোট খতিয়ান:</div>
              <div className="text-lg font-semibold" data-id="element-36">{items.length}</div>
            </div>
          </div>
          <button className="w-full py-3 bg-blue-800 hover:bg-blue-700 text-white rounded-md flex items-center justify-center" onClick={handleProceed} data-id="element-37">
            <span data-id="element-38">পেমেন্ট করুন</span>
            <span className="text-xs ml-1" data-id="element-39">(Proceed to Payment)</span>
            <ArrowRightIcon className="h-4 w-4 ml-2" data-id="element-40" />
          </button>
        </div>}
    </>;
  const renderPaymentStep = () => <>
      <div className="flex-1 overflow-y-auto p-4" data-id="element-41">
        <div className="mb-6" data-id="element-42">
          <h3 className="text-lg font-medium mb-4" data-id="element-43">
            পেমেন্ট পদ্ধতি নির্বাচন করুন
          </h3>
          <p className="text-sm text-gray-500 mb-4" data-id="element-44">(Select payment method)</p>
          <div className="space-y-3" data-id="element-45">
            <div className={`border rounded-lg p-3 cursor-pointer ${paymentMethod === 'card' ? 'border-blue-500 bg-blue-50' : ''}`} onClick={() => setPaymentMethod('card')} data-id="element-46">
              <div className="flex items-center" data-id="element-47">
                <CreditCardIcon className="h-5 w-5 mr-3 text-blue-600" data-id="element-48" />
                <div data-id="element-49">
                  <div className="font-medium" data-id="element-50">ক্রেডিট/ডেবিট কার্ড</div>
                  <div className="text-xs text-gray-500" data-id="element-51">
                    (Credit/Debit Card)
                  </div>
                </div>
                {paymentMethod === 'card' && <CheckCircleIcon className="h-5 w-5 ml-auto text-blue-600" data-id="element-52" />}
              </div>
            </div>
            <div className={`border rounded-lg p-3 cursor-pointer ${paymentMethod === 'mobile' ? 'border-blue-500 bg-blue-50' : ''}`} onClick={() => setPaymentMethod('mobile')} data-id="element-53">
              <div className="flex items-center" data-id="element-54">
                <div className="h-5 w-5 mr-3 text-green-600" data-id="element-55">📱</div>
                <div data-id="element-56">
                  <div className="font-medium" data-id="element-57">মোবাইল ব্যাংকিং</div>
                  <div className="text-xs text-gray-500" data-id="element-58">(Mobile Banking)</div>
                </div>
                {paymentMethod === 'mobile' && <CheckCircleIcon className="h-5 w-5 ml-auto text-blue-600" data-id="element-59" />}
              </div>
            </div>
            <div className={`border rounded-lg p-3 cursor-pointer ${paymentMethod === 'bank' ? 'border-blue-500 bg-blue-50' : ''}`} onClick={() => setPaymentMethod('bank')} data-id="element-60">
              <div className="flex items-center" data-id="element-61">
                <div className="h-5 w-5 mr-3 text-blue-800" data-id="element-62">🏦</div>
                <div data-id="element-63">
                  <div className="font-medium" data-id="element-64">ব্যাংক ট্রান্সফার</div>
                  <div className="text-xs text-gray-500" data-id="element-65">(Bank Transfer)</div>
                </div>
                {paymentMethod === 'bank' && <CheckCircleIcon className="h-5 w-5 ml-auto text-blue-600" data-id="element-66" />}
              </div>
            </div>
          </div>
        </div>
        <div className="mb-6" data-id="element-67">
          <h3 className="text-lg font-medium mb-2" data-id="element-68">অর্ডার সারাংশ</h3>
          <p className="text-sm text-gray-500 mb-3" data-id="element-69">(Order Summary)</p>
          <div className="bg-gray-50 rounded-lg p-3 border" data-id="element-70">
            <div className="flex justify-between mb-2" data-id="element-71">
              <span data-id="element-72">মোট খতিয়ান:</span>
              <span className="font-medium" data-id="element-73">{items.length}</span>
            </div>
            <div className="flex justify-between mb-2" data-id="element-74">
              <span data-id="element-75">প্রক্রিয়াকরণ ফি:</span>
              <span className="font-medium" data-id="element-76">৳ {items.length * 50}</span>
            </div>
            <div className="border-t my-2 pt-2 flex justify-between font-semibold" data-id="element-77">
              <span data-id="element-78">সর্বমোট:</span>
              <span data-id="element-79">৳ {items.length * 50}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4 border-t" data-id="element-80">
        <div className="grid grid-cols-2 gap-3" data-id="element-81">
          <button className="py-3 border border-gray-300 text-gray-700 rounded-md flex items-center justify-center" onClick={handleBack} data-id="element-82">
            <span data-id="element-83">পিছনে</span>
            <span className="text-xs ml-1" data-id="element-84">(Back)</span>
          </button>
          <button className={`py-3 bg-blue-800 hover:bg-blue-700 text-white rounded-md flex items-center justify-center ${!paymentMethod && 'opacity-50 cursor-not-allowed'}`} onClick={handleProceed} disabled={!paymentMethod} data-id="element-85">
            <span data-id="element-86">পেমেন্ট করুন</span>
            <span className="text-xs ml-1" data-id="element-87">(Pay)</span>
          </button>
        </div>
      </div>
    </>;
  const renderConfirmationStep = () => <>
      <div className="flex-1 overflow-y-auto p-4" data-id="element-88">
        <div className="flex flex-col items-center justify-center text-center py-6" data-id="element-89">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4" data-id="element-90">
            <CheckCircleIcon className="h-10 w-10 text-green-600" data-id="element-91" />
          </div>
          <h3 className="text-xl font-medium text-gray-800 mb-2" data-id="element-92">
            অর্ডার সফল হয়েছে!
          </h3>
          <p className="text-sm text-gray-500 mb-6" data-id="element-93">(Order Successful!)</p>
          <div className="bg-gray-50 rounded-lg p-4 border w-full mb-6" data-id="element-94">
            <div className="text-left mb-3" data-id="element-95">
              <div className="text-sm text-gray-500" data-id="element-96">অর্ডার আইডি:</div>
              <div className="font-medium" data-id="element-97">
                #KH{Math.floor(Math.random() * 10000)}
              </div>
            </div>
            <div className="text-left mb-3" data-id="element-98">
              <div className="text-sm text-gray-500" data-id="element-99">পেমেন্ট পদ্ধতি:</div>
              <div className="font-medium" data-id="element-100">
                {paymentMethod === 'card' && 'ক্রেডিট/ডেবিট কার্ড'}
                {paymentMethod === 'mobile' && 'মোবাইল ব্যাংকিং'}
                {paymentMethod === 'bank' && 'ব্যাংক ট্রান্সফার'}
              </div>
            </div>
            <div className="text-left" data-id="element-101">
              <div className="text-sm text-gray-500" data-id="element-102">মোট পরিমাণ:</div>
              <div className="font-medium" data-id="element-103">৳ {items.length * 50}</div>
            </div>
          </div>
          <button className="mb-3 w-full py-3 bg-blue-800 hover:bg-blue-700 text-white rounded-md flex items-center justify-center" data-id="element-104">
            <DownloadIcon className="h-4 w-4 mr-2" data-id="element-105" />
            <span data-id="element-106">রসিদ ডাউনলোড করুন</span>
          </button>
          <button className="w-full py-3 border border-blue-800 text-blue-800 hover:bg-blue-50 rounded-md flex items-center justify-center" data-id="element-107">
            <ShoppingBagIcon className="h-4 w-4 mr-2" data-id="element-108" />
            <span data-id="element-109">আরও খতিয়ান খুঁজুন</span>
          </button>
        </div>
      </div>
      <div className="p-4 border-t" data-id="element-110">
        <button className="w-full py-3 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-md flex items-center justify-center" onClick={() => {
        setCheckoutStep('cart');
        onClear();
        onClose();
      }} data-id="element-111">
          <span data-id="element-112">সমাপ্ত করুন</span>
          <span className="text-xs ml-1" data-id="element-113">(Finish)</span>
        </button>
      </div>
    </>;
  const renderStepContent = () => {
    switch (checkoutStep) {
      case 'payment':
        return renderPaymentStep();
      case 'confirmation':
        return renderConfirmationStep();
      default:
        return renderCartStep();
    }
  };
  const getStepTitle = () => {
    switch (checkoutStep) {
      case 'payment':
        return 'পেমেন্ট (Payment)';
      case 'confirmation':
        return 'নিশ্চিতকরণ (Confirmation)';
      default:
        return 'আপনার কার্ট (Your Cart)';
    }
  };
  return <>
      {/* Overlay for mobile */}
      <div className={`md:hidden fixed inset-0 bg-gray-800 bg-opacity-75 z-40 transition-opacity ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={checkoutStep === 'cart' ? onClose : null} data-id="element-114" />
      {/* Drawer */}
      <div className={`fixed inset-y-0 right-0 w-full max-w-md bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-115">
        <div className="h-full flex flex-col" data-id="element-116">
          {/* Header */}
          <div className="p-4 border-b flex justify-between items-center" data-id="element-117">
            <h2 className="text-lg font-semibold" data-id="element-118">{getStepTitle()}</h2>
            {checkoutStep === 'cart' && <button className="p-1 rounded-full hover:bg-gray-200" onClick={onClose} data-id="element-119">
                <XIcon className="h-5 w-5" data-id="element-120" />
              </button>}
          </div>
          {/* Progress Steps */}
          {items.length > 0 && <div className="px-4 py-2 border-b" data-id="element-121">
              <div className="flex items-center" data-id="element-122">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${checkoutStep === 'cart' ? 'bg-blue-600 text-white' : 'bg-blue-100 text-blue-800'}`} data-id="element-123">
                  1
                </div>
                <div className={`flex-1 h-1 mx-2 ${checkoutStep === 'cart' ? 'bg-gray-200' : 'bg-blue-600'}`} data-id="element-124"></div>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${checkoutStep === 'payment' ? 'bg-blue-600 text-white' : checkoutStep === 'confirmation' ? 'bg-blue-100 text-blue-800' : 'bg-gray-200 text-gray-600'}`} data-id="element-125">
                  2
                </div>
                <div className={`flex-1 h-1 mx-2 ${checkoutStep === 'confirmation' ? 'bg-blue-600' : 'bg-gray-200'}`} data-id="element-126"></div>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${checkoutStep === 'confirmation' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600'}`} data-id="element-127">
                  3
                </div>
              </div>
            </div>}
          {/* Content based on step */}
          {renderStepContent()}
        </div>
      </div>
    </>;
};
// Import needed for empty state
import { ShoppingCartIcon } from 'lucide-react';